export const resetToInitialState = (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
};
